import { kebabCase } from 'lodash';
import React, { Component } from 'react';
import { createHashHistory } from 'history';
import { v4 as uuidV4 } from 'uuid';
import PropTypes from 'prop-types';
import { Col, Container, Row } from 'reactstrap';
import { editPermissionSelector, viewPermissionSelector } from '../../common/classes/permissions';
import routeHelper from '../../common/classes/routeHelper';
import ListPanel from '../../common/containers/listPanel';
import OrganizationsFilters from './organizationsFilters';
import OrganizationsPagingTable from './organizationsPagingTable';
import OrganizationRow from './organizationRow';
import entityComposition from '../../common/classes/entityComposition';
const hashHistory = createHashHistory();
const handleClick = id => hashHistory.push(`/admin/organizations/${id}`);
class Organizations extends Component {
  constructor(props) {
    super(props);
    this.handleAdd = this.handleAdd.bind(this);
  }
  componentDidMount() {
    const {
      canView,
      location,
      organization,
      organizationActions
    } = this.props;
    routeHelper.handleViewRedirect(canView, location);
    organizationActions.serverIndex(organization.indexQuery);
  }
  handleAdd() {
    const {
      userID,
      organizationActions
    } = this.props;
    const orgID = uuidV4().toUpperCase();
    organizationActions.create(orgID, userID);
    hashHistory.push(`/admin/organizations/${orgID}`);
  }
  render() {
    const {
      organization,
      canEdit
    } = this.props;
    return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      sm: 3
    }, /*#__PURE__*/React.createElement(OrganizationsFilters, null)), /*#__PURE__*/React.createElement(Col, {
      sm: 9
    }, /*#__PURE__*/React.createElement(ListPanel, {
      title: "Organizations",
      showNew: canEdit,
      onAdd: this.handleAdd
    }, /*#__PURE__*/React.createElement(OrganizationsPagingTable, {
      headers: ['Name'],
      loading: organization.loading,
      indexQuery: organization.indexQuery,
      hideSortOptions: true
    }, organization.list.map((item, index) => /*#__PURE__*/React.createElement(OrganizationRow, {
      className: `t-or-${index} t-or-name-${kebabCase(item.name)}`,
      key: item.id,
      id: item.id,
      onClick: handleClick
    }, /*#__PURE__*/React.createElement("td", null, item.name))))))));
  }
}
Organizations.propTypes = {
  canEdit: PropTypes.bool.isRequired,
  canView: PropTypes.bool.isRequired,
  organization: PropTypes.shape({
    filters: PropTypes.shape({
      text: PropTypes.string
    }),
    indexQuery: PropTypes.shape({}),
    list: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string
    })),
    loading: PropTypes.bool
  }).isRequired,
  location: PropTypes.shape({}).isRequired,
  organizationActions: PropTypes.shape({
    create: PropTypes.func,
    serverIndex: PropTypes.func
  }).isRequired,
  userID: PropTypes.string.isRequired
};
export { Organizations as TestOrganizations };
export default entityComposition(Organizations, ['organization'], {
  canEdit: state => editPermissionSelector('organization')(state),
  canView: state => viewPermissionSelector('organization')(state),
  userID: state => state.login.user.user_id
});